import React, { useContext } from "react";
import { OrderContext } from "../../OrderContext.tsx";
import { Product, Variant } from "../../types.ts";
import { addToCartEvent } from "../../../../../misc/analytics.ts";
import ProductCard from "./ProductCard.tsx";

function B2BProductCard({ products, product, actionButtonText, horizontal }: { products: Product[], product: Product, actionButtonText?: string; horizontal: boolean }) {
  
  const { handleFormChange, formValues, toPhase, discountRows } = useContext(OrderContext);

  const handleClick = (selectedVariant: Variant) => {
    const variantId = selectedVariant.contract_template_id
    const data = { name: 'product', value: variantId };
    handleFormChange({ target: data } as React.ChangeEvent<HTMLInputElement>);
    addToCartEvent(selectedVariant, formValues);
    toPhase(3, false, variantId);
  }

  return (
    <>
      <ProductCard product={product} horizontal={horizontal} actionButtonText={actionButtonText} discountRows={discountRows} onClick={handleClick} />
    </>
  )
}

export default B2BProductCard;
